/* angular:styles/component:css;460dd2201f2e0ec5f5910d6fa29378ae4b244246967d4edd165a60830abf6ae8;/vercel/path0/src/app/datepicker/datepicker-ita/datepicker-ita.component.ts */
.custom-day {
  text-align: center;
  padding: 0.185rem 0.25rem;
  display: inline-block;
  height: 2rem;
  width: 2rem;
}
.custom-day.focused {
  background-color: #e6e6e6;
}
.custom-day.range,
.custom-day:hover {
  background-color: rgb(2, 117, 216);
  color: white;
}
.custom-day.faded {
  background-color: rgba(2, 117, 216, 0.5);
}
/*# sourceMappingURL=datepicker-ita.component.css.map */
